import React, {Component} from "react";

import LoaderButton from "../components/LoaderButton";
import { Auth, API } from "aws-amplify";
import Confirmation from "./Confirmation";

export default class Signup extends Component {
  constructor(props){
    super(props);

    this.state = {
        isLoading: false,
        fullname: "",
        email: "",
        password: "",
        confirmPassword: "",
        confirmationCode: "",
        newUser: null,
        errorMsg: "",
        termsandconditions: "false",
        termsandconditionsUI: false,
        shareDetails: "false",
        shareDetailsUI: false
    };
  }

  validateForm() {
    if(this.state.fullname.length === 0){
      return false
    }
    if(this.state.email.length === 0){
      return false;
    }
    if(this.state.password.length < 8){
      return false;
    }
    if(this.state.confirmPassword !== this.state.password){
      return false;
    }
    if(this.state.termsandconditions === "false"){
      return false;
    }

    return true;
  }

  handleChange = event => {

    this.setState({
      [event.target.id]: event.target.value
    });

  }

  handleTermsNConditions = event => {

    this.setState({
      [event.target.id]: !this.state[event.target.id+"UI"]+"",
      [event.target.id+"UI"]: !this.state[event.target.id+"UI"]

    });
  }



  handleSubmit = async event => {
    event.preventDefault();
    if(this.state.fullname.length === 0){
      this.setState({errorMsg: "Please enter your Full Name"});
      return;
    }

    if(this.state.email.length === 0){
      this.setState({errorMsg: "Email cannot be empty."});
      return;
    }

    if(this.state.password.length < 8){
      this.setState({errorMsg: "Password should have minimum 8 characters"});
      return;
    }

    if(this.state.confirmPassword !== this.state.password){

        this.setState({errorMsg: "'Password' and 'Confirm Password' DO NOT match"});
        return;

    }

    if(this.state.termsandconditions === "false"){
      this.setState({errorMsg: "Please Accept our Terms and Conditions to proceed."});
      return;
    }


    this.setState( { isLoading: true, errorMsg: "" } );

    try{
        const newUser = await Auth.signUp({
          username: this.state.email,
          password: this.state.password,
          attributes: {
            name: this.state.fullname
          }
        });

        this.setState({
           newUser
        });

    }catch(e){
        this.setState({errorMsg: e.message});
    }


    this.setState( { isLoading: false } );
  }

  addUserProfileToServer(userInfo){
    API.post("retnetindia", "/user/profile", {
      body: userInfo
    })
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div class="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

  renderModalDialogForTermsAndConditions(){
    return(
      <div className="modal fade" id="termsandconditionspopup" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title retnet-black-font" >Terms & Conditions</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body retnet-black-font">
                   <h1> For Doctors Only </h1>


                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary" data-dismiss="modal">Got It</button>

                </div>
              </div>
            </div>
      </div>
    );
  }

  renderNewSignupForm(){
    return(
      <div className="loginContainer">
            <div className="login-header retnet-yrsa-font">
                <h4>SIGNUP NOW</h4>
            </div>
          {this.getErrorElement()}
          <form className="form-default" role="form" onSubmit={this.handleSubmit} >
              <div className="row">
                  <div className="col-12">
                      <div className="form-group">

                          <input type="text" id="fullname"
                              className="form-control form-control-lg"
                              value={this.state.fullname}
                              onChange={this.handleChange}
                              placeholder="Please enter your Full Name"
                              className="form-control form-control-lg rounded" />

                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-12">
                      <div className="form-group">

                          <input type="email" id="email"
                             value={this.state.email}
                             onChange={this.handleChange}
                             placeholder="Please enter your Email Id"
                             className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-lg-12">
                      <div className="form-group has-feedback">

                          <input type="password"
                                id="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                                placeholder="Please enter your password"
                                className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-lg-12">
                      <div className="form-group has-feedback">

                          <input type="password"
                                id="confirmPassword"
                                value={this.state.confirmPassword}
                                onChange={this.handleChange}
                                placeholder="Retype your password"
                                className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-lg-12">
                      <div className="form-group has-feedback">

                      <div className="checkbox">
                         <input type="checkbox"
                                name="shareDetails"
                                onChange={this.handleTermsNConditions}
                                checked={this.state.shareDetailsUI}
                                id="shareDetails"
                                className="left-padding"/>
                           <label className="retnet-white-color-no-border">
                                Share my profile details with other doctors
                          </label>
                      </div>
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-lg-12">
                      <div className="form-group has-feedback">

                      <div className="checkbox">
                         <input type="checkbox"
                                name="termsandconditions"
                                onChange={this.handleTermsNConditions}
                                checked={this.state.termsandconditionsUI}
                                id="termsandconditions"
                                className="left-padding"/>
                           <label className="retnet-white-color-no-border">
                               I accept the &nbsp;
                               <a title="This should be terms and conditions"
                                   data-toggle="modal"
                                   data-target="#termsandconditionspopup">
                                 Terms & Conditions
                              </a>
                          </label>
                      </div>
                      </div>
                  </div>
              </div>



              <LoaderButton block bsSize="large"
                           disabled = {!this.validateForm()}
                           type="submit"
                           isLoading={this.state.isLoading}
                           text="Sign Up"
                           loadingText="Signing Up..."
                           className="btn btn-lg btn-block btn-success rounded retnet-16-font-size retnet-bold-font"/>

          </form>

           {this.renderModalDialogForTermsAndConditions()}
      </div>
    );
  }

  renderSignupForm(){
    return(
        <section className="slice sct-color-2 loginpagebg">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="card form-card form-card--style-2">
                            <div className="form-header text-center">
                                <div className="form-header-icon">
                                      <img src="/images/logo_retnetindia.png" />
                                </div>
                            </div>
                            <div className="form-body">
                                <div className="text-center px-2">
                                    <h4 className="heading heading-4 strong-400 mb-0">Create a new account</h4>
                                </div>
                                {this.getErrorElement()}
                                <form onSubmit={this.handleSubmit} className="form-default mt-4" data-toggle="validator" role="form">

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">Email</label>
                                                <input type="email" id="email"
                                                     className="form-control form-control-lg"
                                                     value={this.state.email}
                                                     onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">Full Name</label>
                                                <input type="text" id="fullname"
                                                  className="form-control form-control-lg"
                                                  value={this.state.fullname}
                                                  onChange={this.handleChange} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">Password</label>
                                                <input type="password" id="password"
                                                  value={this.state.password}
                                                  onChange={this.handleChange}
                                                   className="form-control form-control-lg"/>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group has-feedback">
                                                <label className="control-label">Confirm Password</label>
                                                <input type="password"
                                                  id="confirmPassword"
                                                  value={this.state.confirmPassword}
                                                  onChange={this.handleChange}
                                                  className="form-control form-control-lg" />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="checkbox">
                                       <input type="checkbox"
                                              name="termsandconditions"
                                              onChange={this.handleTermsNConditions}
                                              checked={this.state.termsandconditionsUI}
                                              id="termsandconditions" />
                                         <label for="termsandconditions">
                                             I accept the <a title="This should be terms and conditions">Terms & Conditions</a> of Retnet India
                                        </label>
                                    </div>

                                    <div className="text-center">
                                        {
                                          this.validateForm()
                                                ?   <LoaderButton block bsSize="large"e
                                                          type="submit"
                                                          isLoading={this.state.isLoading}
                                                          text="Signup"
                                                          loadingText="Signing Up..."
                                                          className="btn btn-styled btn-lg btn-info mt-4"/>
                                                :    <LoaderButton block disabled bsSize="large"
                                                          type="submit"
                                                          isLoading={this.state.isLoading}
                                                          text="Signup"
                                                          loadingText="Signing Up..."
                                                          className="btn btn-styled btn-lg btn-info mt-4"/>

                                        }

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
  }

  render(){
    return(
      <div className="Signup">
          {this.state.newUser === null
              ? this.renderNewSignupForm()
              : <Confirmation email={this.state.email}
                             fullname={this.state.fullname}
                             password={this.state.password}
                             history={this.props.history}
                             shareDetails={this.state.shareDetails}
                             userHasAuthenticated={this.props.userHasAuthenticated}/>

          }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/containers/NewSignup.js